import { AddOrUpdateSetting } from "../Models/Setting/AddOrUpdateSetting";

export class SettingsDataService {
    public static getSettingDefinitionsWithValues(callback: (output: any) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/settings/definitionsandvalues`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static addOrUpdateSettingValue(settingValue : AddOrUpdateSetting, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/settings/addorupdate`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            data: JSON.stringify(settingValue),
            success: callback,
            error: () => {
                error && error();
            }
        });
    }
}